import React from 'react'
import cn from 'classnames'
import { useTranslation } from 'lib/i18n'

import styles from 'components/ProductPage/shared/Instructions.module.css'
import { Button } from 'components/UI/Button/Button'
import { IconDelete, IconLongerInstruction } from 'components/UI/Icons'
import Typography from 'components/UI/Typography/Typography'

export default function ExtendedInstructionsAddon({
  extendedInstructionsActive,
  extendedInstructionsProduct,
  textTooLong,
  toggleExtendedInstructions,
}) {
  const { t } = useTranslation()

  const price = extendedInstructionsProduct.price.formattedValue

  return (
    <div
      className={cn(styles.instructions, {
        [styles.active]: extendedInstructionsActive,
      })}
    >
      {textTooLong && !extendedInstructionsActive && (
        <p className={styles.instructionsExtendMessage}>
          {t(
            'ExtendedInstructionsAddon.addToWriteLonger',
            'Getting a bit long there! Add more characters.',
          )}
        </p>
      )}

      <div className={styles.extendedInstructions}>
        <IconLongerInstruction className={styles.longerInstructionIcon} />
        <div className={styles.extendedInstructionsText}>
          <Typography.BodyBold>
            <strong>
              {t(
                'ExtendedInstructionsAddon.writeLongerInstructions',
                'Write longer instructions',
              )}
            </strong>
          </Typography.BodyBold>
          <Typography.BodySmall className={styles.subtitle}>
            {t(
              'ExtendedInstructionsAddon.writeLongerInstructionsSubtitle',
              'Write up to 600 characters in your instructions',
            )}
          </Typography.BodySmall>
          <Typography.BodySmallBold className={styles.price}>
            {price}
          </Typography.BodySmallBold>
        </div>

        {extendedInstructionsActive ? (
          <button
            type="button"
            onClick={toggleExtendedInstructions}
            data-cy="extendedInstructionsToggleButtonRemove"
            className={styles.remove}
          >
            <IconDelete className={styles.deleteIcon} />
          </button>
        ) : (
          <Button
            size="small"
            type="primary"
            onClick={toggleExtendedInstructions}
            data-cy="extendedInstructionsToggleButtonAdd"
          >
            {t('ExtendedInstructionsAddon.add1', 'Add')}
          </Button>
        )}
      </div>
    </div>
  )
}
